var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('a',{attrs:{"href":"http://applyit.lv","target":"_blank"}},[_vm._v("Apply")]),_vm._v(" © 2018\n  ")])
}]

export { render, staticRenderFns }